<fury-page-layout mode="card">
    <fury-page-layout-header>
      <fury-breadcrumbs [@fadeInRight]  current="Agreement Details"></fury-breadcrumbs>
    </fury-page-layout-header>
  
    <fury-page-layout-content [@fadeInUp]>
      <fury-list name='Agreement details' [columns]="displayedColumns">
        <div class="actions">
            <button *ngIf=" itemList?.length > 0"
              class="create"
              type="button"
              mat-mini-fab
              color="primary"
              [routerLink]="['/customer-agreement/edit-customer-agreement', itemList?.length > 0 ? itemList[0]?.customerAgreementVersionId : '']"
              [state]="{ agreementVersion: itemList[0]?.agreementVersion }"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </div>

          <table mat-table [dataSource]="dataSource">
            <ng-container matColumnDef="agreementNumber">
              <th mat-header-cell *matHeaderCellDef>Agreement no.</th>
              <td mat-cell *matCellDef="let element">{{ element.agreementNumber }}</td>
            </ng-container>
             <ng-container matColumnDef="agreementVersion">
              <th mat-header-cell *matHeaderCellDef>Version</th>
              <td mat-cell *matCellDef="let element">{{ element.agreementVersion }}</td>
            </ng-container>
            <ng-container matColumnDef="total_amount">
              <th mat-header-cell *matHeaderCellDef>Total amount</th>
              <td mat-cell *matCellDef="let element">{{ element.total_amount }}</td>
            </ng-container>
    
            <ng-container matColumnDef="firstName">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
            </ng-container>
    
            <ng-container matColumnDef="lastName">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
            </ng-container>
    
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef>Actions</th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-menu-item
                  [routerLink]="['/customer-agreement/customer-agreement-pdf', itemList[0]?.customerAgreementVersionId]"
                >
                <mat-icon>picture_as_pdf</mat-icon>
                </button>
              </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns  | paginate: { id: 'server', itemsPerPage: pageSize, currentPage: pageIndex, totalItems: totalCount }"></tr>
          </table>
          <!-- <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)"
          showFirstLastButtons
                    [selectConfig] = "selectConfig"
                    [ngClass]="{'mat-pegig': pageSize === 9999}"
                    aria-label="Select page of periodic elements">
      </mat-paginator> -->
       
      </fury-list>
  
    </fury-page-layout-content>
  </fury-page-layout>
  





